export enum MediaListProperties {
  Name = 'name',
  Description = 'description',
  IsCurated = 'isCurated',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
  MediaListItems = 'mediaListItems',
  Zone = 'zone',
  Released = 'released',
  ReleaseAction = 'releaseAction',
}
export enum MediaListMetaProperties {
  MediaListItemsId = 'MediaListItems-id',
  MediaListItemsVersion = 'MediaListItems-version',
  ZoneId = 'Zone-id',
  ZoneVersion = 'Zone-version',
  ReleaseActionId = 'ReleaseAction-id',
  ReleaseActionVersion = 'ReleaseAction-version',
}
